import api from './api';

const service = {
  fetch: params => api.get('favorites', params),
  favorite: params => api.post('favorites', params),
  unfavorite: id => api.delete(`favorites/${id}`),
};

export default service;
